import React from "react";
import clsx from "clsx";
import { DLSButton } from "../DLSButton";
import * as styles from "./index.module.scss";

export const DLSButtonV2 = ({
  layout = "primary",
  customClass = "",
  ...rest
}) => {
  const buttonClasses = clsx(styles.buttonV2, styles[layout], customClass);

  return <DLSButton customClass={buttonClasses} {...rest} />;
};
